// frontend/apps/widgets/src/widgets/GiftVoucher/components/GiftVoucherGrid.js
import React from 'react';
import PropTypes from 'prop-types';
import {Grid} from '@mui/material';
import GiftVoucherCard from './GiftVoucherCard';

function GiftVoucherGrid({
  voucherTypes,
  categories,
  companyDetails,
  primaryColor,
}) {
  if (!voucherTypes || voucherTypes.length === 0) {
    return null;
  }

  const usedPrimaryColor = primaryColor || companyDetails?.branding?.primaryColor || companyDetails?.primaryColor || '#078DEE';

  return (
    <Grid
      container
      spacing={{xs: 4, sm: 4, md: 6, lg: 6}}
      alignItems="center"
      justifyContent="center"
      sx={{
        pt: 6,
        pb: 4,
        flexDirection: {xs: 'column', sm: 'row'},
      }}
    >
      {voucherTypes.map((voucher, index) => {
        const uniqueKey = voucher._id || voucher.id || `voucher-${index}`;

        return (
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            lg={4}
            key={uniqueKey}
            width="100%"
            sx={{marginTop: {xs: -2, sm: 0}}}
          >
            <GiftVoucherCard
              voucher={voucher}
              categories={categories}
              companyDetails={companyDetails}
              color={usedPrimaryColor}
            />
          </Grid>
        );
      })}
    </Grid>
  );
}

GiftVoucherGrid.propTypes = {
  voucherTypes: PropTypes.array.isRequired,
  categories: PropTypes.array,
  companyDetails: PropTypes.object.isRequired,
  primaryColor: PropTypes.string,
};

export default GiftVoucherGrid;
